import { SelectOption } from './types'

export const visitDurationOptions: SelectOption[] = [
	{ value: '15', label: '15 minutes' },
	{ value: '30', label: '30 minutes' },
	{ value: '45', label: '45 minutes' },
	{ value: '60', label: '60 minutes' }
]

export const paddingTimeOptions: SelectOption[] = [
	{ value: '0', label: '0 minutes' },
	{ value: '5', label: '5 minutes' },
	{ value: '10', label: '10 minutes' },
	{ value: '15', label: '15 minutes' }
]

export const daysBeforeVisitOptions: SelectOption[] = [
	{ value: '1', label: '1 day' },
	{ value: '2', label: '2 days' },
	{ value: '3', label: '3 days' },
	{ value: '4', label: '4 days' },
	{ value: '5', label: '5 days' }
]
